import React from 'react'
import { callSummary, chatSummary } from '../../../assets/data/callSummary'
import styles from './styles.module.css'


const SummaryList = (props: any) => {

    const summaryData = props.type === 'call' ? callSummary : chatSummary;

    const list = summaryData && summaryData.length > 0 && summaryData.map(item => {
        return  <div className={`col-4 ${styles.metricItem}`} key={item.id}>
                    <div className={`${styles.innerSummary}`}>
                        <h6>{item.title}</h6>
                        <div>
                            <span className={styles.metricCount}>
                                {item.count}
                                {item.rating && <i className={`bi bi-star-fill ${styles.biStartFill}`}></i>}
                            </span>
                            <span className={styles.metricVariation}><i className={`bi bi-chevron-up ${styles.biChevronUp}`}></i>{item.by}</span>
                        </div>
                    </div>
                </div>
    })

    return (
        <div className="row">
            {list}
        </div>
    )
}

export default SummaryList
